import React from "react";
import { Check, X } from "lucide-react";

const FOR_YOU = [
  "Your account is suspended, disabled, banned, or restricted on Instagram, Facebook, TikTok, YouTube, or X",
  "You've tried the standard in-app appeal and got an automated rejection (or no response)",
  "Your account drives real income, audience, or years of irreplaceable content",
  "You want a thorough, policy-aware appeal package — not a copy-paste template",
];

const NOT_FOR_YOU = [
  "You're looking for someone who promises to \"guarantee\" reinstatement (that's a scam)",
  "You want a $5 Fiverr-style template or DIY tutorial",
  "You're unwilling to provide accurate account history and supporting context",
  "Your case involves CSAM, terrorism, or other irrecoverable policy categories",
];

export const Qualifier = () => (
  <section className="py-20 bg-slate-900/40" id="qualifier" data-testid="qualifier-section">
    <div className="mx-auto max-w-6xl px-6">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold">
          Is This Service
          <span className="text-blue-400"> Right for You?</span>
        </h2>
        <p className="mt-4 text-slate-400 max-w-2xl mx-auto">
          We're selective about the cases we take. Read this before booking — it saves us both time.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div
          className="rounded-2xl border border-green-500/30 bg-green-500/5 p-8"
          data-testid="qualifier-for-you"
        >
          <h3 className="text-xl font-semibold text-green-400 mb-6">This is for you if…</h3>
          <ul className="space-y-4">
            {FOR_YOU.map((line) => (
              <li key={line} className="flex items-start gap-3 text-slate-200 leading-relaxed">
                <span className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center">
                  <Check className="w-4 h-4 text-green-400" />
                </span>
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </div>

        <div
          className="rounded-2xl border border-red-500/20 bg-red-500/5 p-8"
          data-testid="qualifier-not-for-you"
        >
          <h3 className="text-xl font-semibold text-red-400 mb-6">This is NOT for you if…</h3>
          <ul className="space-y-4">
            {NOT_FOR_YOU.map((line) => (
              <li key={line} className="flex items-start gap-3 text-slate-300 leading-relaxed">
                <span className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full bg-red-500/20 flex items-center justify-center">
                  <X className="w-4 h-4 text-red-400" />
                </span>
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
